import { call, getContext, put, select, takeLatest } from 'redux-saga/effects';
import { handleErrorMessage } from '../../../adapters/primary/libs/handleErrorMessage';
import { selectCurrentParticipantId } from '../../../module/participant/participant.slice';
import { Invoice } from '../../models/entities/billing-new/invoice';
import { setError } from '../error/errorActions';
import { selectOperationParticipants } from '../participants/participantsSelector';
import { BillingNewActions } from './billingNewActions';
import { DOWNLOAD_INVOICE, GET_ALL_INVOICES, GET_INVOICES } from './billingNewConstants';
import { billingNewGatewayInterface } from './billingNewGatewayInterface';

function* getAllInvoices() {
  try {
    const billingNewGatewayInterface: billingNewGatewayInterface = yield getContext('billingNewGatewayContext');
    const participants: any[] = yield select(selectOperationParticipants);
    if (!participants || !participants.length) {
      return;
    }
    const invoices: Invoice[] = yield call(
      billingNewGatewayInterface.getInvoices,
      participants.map((part) => part._id),
    );
    yield put(BillingNewActions.setInvoices(invoices));
  } catch (error: any) {
    console.error('Fetch All Invoices...', error);
    yield put(
      setError({
        status: error?.response?.status,
        message: '[GET All Invoices] : ' + handleErrorMessage(error?.response?.status),
      }),
    );
  }
}

function* getInvoices() {
  try {
    const participantId: number = yield select(selectCurrentParticipantId);
    const billingNewGatewayInterface: billingNewGatewayInterface = yield getContext('billingNewGatewayContext');
    const invoices: Invoice[] = yield call(billingNewGatewayInterface.getInvoices, [participantId]);
    yield put(BillingNewActions.setInvoices(invoices));
  } catch (error: any) {
    console.error('Fetch Invoices...', error);
    yield put(
      setError({
        status: error?.response?.status,
        message: '[GET Invoices] : ' + handleErrorMessage(error?.response?.status),
      }),
    );
  }
}
function* downloadInvoice(action: any) {
  try {
    const participantId: number = yield select(selectCurrentParticipantId);
    const { invoiceId, lang, isLegacyBill, participantInvoiceId } = action.payload;
    const billingNewGatewayInterface: billingNewGatewayInterface = yield getContext('billingNewGatewayContext');
    yield call(
      billingNewGatewayInterface.downloadInvoice,
      participantInvoiceId || participantId,
      invoiceId,
      lang,
      isLegacyBill,
    );
  } catch (error: any) {
    console.error(error);
    yield put(
      setError({
        status: error.response.status,
        message: '[GET DownloadInvoice] : ' + handleErrorMessage(error.response.status),
      }),
    );
  }
}

export function* downloadInvoiceSaga() {
  yield takeLatest(DOWNLOAD_INVOICE, downloadInvoice);
}

export function* getInvoicesSaga() {
  yield takeLatest(GET_INVOICES, getInvoices);
}

export function* getAllInvoicesSaga() {
  yield takeLatest(GET_ALL_INVOICES, getAllInvoices);
}

export default [getInvoicesSaga, downloadInvoiceSaga, getAllInvoicesSaga];
